import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { Menu } from 'lucide-react';

const Layout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="min-h-screen bg-wedding-beige-50 text-gray-800 font-montserrat">
      <button
        onClick={toggleSidebar}
        className="fixed top-4 left-4 z-50 p-2 bg-wedding-white rounded-full shadow-md hover:shadow-lg transition-all duration-300"
        aria-label="Menu"
      >
        <Menu size={24} className="text-wedding-blue-700" />
      </button>
      
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      
      <main className="min-h-screen">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;